(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial_home"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const containers = document.querySelectorAll('.crs-slider-container');

    containers.forEach(container => {
      const track = container.querySelector('.crs-track');
      const cards = container.querySelectorAll('.crs-card');
      const nextBtn = container.querySelector('.crs-next');
      const prevBtn = container.querySelector('.crs-prev');
      
      if (!cards.length) return;

      let currentIndex = 0;
      let isDragging = false;
      let startPos = 0;
      let currentTranslate = 0;
      let prevTranslate = 0;
      let animationID;
      
      // Auto Scroll settings
      const autoPlayEnabled = container.dataset.autoplay === 'true';
      const speed = parseInt(container.dataset.speed) * 1000;
      let autoPlayInterval;

      // Calculate items per view based on CSS
      function getItemsPerView() {
        const width = window.innerWidth;
        if (width <= 480) return 1;
        if (width <= 768) return 2;
        if (width <= 1024) return 3;
        return 4;
      }

      function updateSlider() {
        const cardWidth = cards[0].offsetWidth;
        const gap = 20; // Matches CSS gap
        const moveAmount = (cardWidth + gap) * currentIndex;
        track.style.transform = `translateX(-${moveAmount}px)`;
        
        // Button Logic
        const totalItems = cards.length;
        const itemsPerView = getItemsPerView();
        
        if(prevBtn) prevBtn.disabled = currentIndex === 0;
        if(nextBtn) nextBtn.disabled = currentIndex >= totalItems - itemsPerView;
      }

      function moveNext() {
        const totalItems = cards.length;
        const itemsPerView = getItemsPerView();
        
        if (currentIndex < totalItems - itemsPerView) {
          currentIndex++;
        } else {
          currentIndex = 0; // Loop back to start
        }
        updateSlider();
      }

      function movePrev() {
        if (currentIndex > 0) {
          currentIndex--;
          updateSlider();
        }
      }

      // Event Listeners
      if(nextBtn) nextBtn.addEventListener('click', () => {
        moveNext();
        resetTimer();
      });
      
      if(prevBtn) prevBtn.addEventListener('click', () => {
        movePrev();
        resetTimer();
      });

      // Auto Play Logic
      function startAutoPlay() {
        if (!autoPlayEnabled) return;
        stopAutoPlay(); // Clear existing to prevent duplicates
        autoPlayInterval = setInterval(moveNext, speed);
      }

      function stopAutoPlay() {
        clearInterval(autoPlayInterval);
      }

      function resetTimer() {
        stopAutoPlay();
        startAutoPlay();
      }

      // Pause on hover
      container.addEventListener('mouseenter', stopAutoPlay);
      container.addEventListener('mouseleave', startAutoPlay);

      // Touch / Swipe Support
      track.addEventListener('touchstart', touchStart);
      track.addEventListener('touchend', touchEnd);
      track.addEventListener('touchmove', touchMove);

      function touchStart(index) {
        return function(event) {
          isDragging = true;
          startPos = getPositionX(event);
          animationID = requestAnimationFrame(animation);
          stopAutoPlay();
        }
      }

      function touchMove(event) {
        if (isDragging) {
          const currentPosition = getPositionX(event);
          currentTranslate = prevTranslate + currentPosition - startPos;
        }
      }

      function touchEnd() {
        isDragging = false;
        cancelAnimationFrame(animationID);
        const movedBy = currentTranslate - prevTranslate;

        if (movedBy < -100) moveNext();
        else if (movedBy > 100) movePrev();
        
        // Reset transform done by drag, let updateSlider handle the snap
        track.style.transform = ''; 
        updateSlider();
        startAutoPlay();
      }

      function getPositionX(event) {
        return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
      }

      function animation() {
        if (isDragging) requestAnimationFrame(animation);
      }

      // Init
      updateSlider();
      startAutoPlay();
      
      // Update on resize
      window.addEventListener('resize', updateSlider);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
